import React from 'react';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import EmptyStates from '../../components/empty-states';
import { useSelector } from '../../components/runtime-context';
import { getQueryLocale } from '../../selectors/locale-selectors';

const NoPostsFeed: React.FC = () => {
  const { t } = useTranslation();
  const { isEditor } = useEnvironment();
  const queryLocale = useSelector(getQueryLocale);
  const isMultilingual = Boolean(queryLocale);

  const title = isMultilingual
    ? t('no-posts-feed.no-published-posts-multilingual')
    : isEditor
    ? t('no-posts-feed.no-posts-to-show')
    : t('no-posts-feed.on-the-way');

  const content = isEditor
    ? t('no-posts-feed.publish-posts-to-see-them')
    : t('no-posts-feed.stay-tuned');

  return <EmptyStates title={title} content={content} />;
};

export default NoPostsFeed;
